import { Address } from '@components/input/address-field';
import { useMemo } from 'react';

// Returns a memoized version of address
export default function useAddressMemo(address: Address): Address {
  const addressLineOne = address?.addressLineOne;
  const addressLineTwo = address?.addressLineTwo;
  const countryId = address?.countryId;
  const postcode = address?.postcode;
  const country = address?.country;
  const county = address?.county;
  const town = address?.town;

  return useMemo(
    () => ({
      addressLineOne,
      addressLineTwo,
      countryId,
      postcode,
      country,
      county,
      town,
    }),
    [addressLineOne, addressLineTwo, country, countryId, county, postcode, town]
  );
}
